import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import { formatCurrencyShortForm } from '@/utils/storage'
import { Talker } from '@/network/api/keyword'

interface Props {
  data: Talker[]
  isLocked: boolean
}

const TopTalkerTable = ({ data, isLocked }: Props) => {
  return (
    <TableContainer component={Paper} style={{ maxHeight: '300px', overflow: 'auto', borderRadius: 8 }}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="top talker table" stickyHeader>
        <TableHead
          sx={{
            backgroundColor: 'rgba(223, 202, 114, 1)',
            height: 10,
          }}
        >
          <TableRow
            sx={{
              height: 10,
              backgroundColor: 'rgba(223, 202, 114, 1)',
              '& .MuiTableCell-head': {
                backgroundColor: 'rgba(223, 202, 114, 1)',
                // fontSize: { xs: 10, sm: 16 },
                lineHeight: 1.5,
              },
            }}
          >
            <TableCell>No</TableCell>
            <TableCell align="left">Username</TableCell>
            <TableCell align="center">Talk</TableCell>
            <TableCell align="center">Followers</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '& .MuiTableCell-body': {},
              }}
            >
              <TableCell component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell align="left" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Typography>{row.fromName}</Typography>
              </TableCell>
              <TableCell align="center" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Tooltip title={Number(row.talk).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography>{formatCurrencyShortForm(row.talk)}</Typography>
                </Tooltip>
              </TableCell>
              <TableCell align="center" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Tooltip title={Number(row.followers).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography>{formatCurrencyShortForm(row.followers)}</Typography>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TopTalkerTable
